<template>
  <div>
    <el-row style="padding-bottom: 10px" @keyup.enter.native="search">
      <el-col :span="24" class="search-box">
        <span
          ><label>编号：</label>
          <el-input
            class="search-input"
            v-model="query.id"
            placeholder="请输入编号"
          ></el-input>
        </span>
        <span
          ><label>名称：</label
          ><el-input
            class="search-input"
            v-model="query.name"
            placeholder="请输入名称"
          ></el-input
        ></span>
        <span
          ><label>所属门店:</label>
          <DropdownSelect
            v-model="query.shopId"
            :action="api.dealer.shop.all"
            textField="name"
            valueField="id"
          ></DropdownSelect>
        </span>
        <span
          ><el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="exportData">导出</el-button></span
        >
      </el-col>
    </el-row>
    <page-table
      :data-api="this.api.dealer.type"
      :viewable="false"
      keyField="id"
    >
      <el-table-column prop="id" label="编号" width="50"></el-table-column>
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column prop="useNumber" label="剩余次数"></el-table-column>
      <el-table-column prop="totalNumber" v-if="!isMobile()" label="总次数"></el-table-column>
      <el-table-column prop="shopName" label="所属门店"></el-table-column>
      <el-table-column prop="workTime" v-if="!isMobile()" label="工作分钟"></el-table-column>
      <el-table-column label="充值" width="50">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="handleRecharge(scope.$index, scope.row)"
            >充值</el-button
          >
        </template>
      </el-table-column>
      <el-table-column v-if="!isMobile()"
        prop="created"
        label="添加时间"
        :formatter="dateFormatter"
      ></el-table-column>
    </page-table>
    <el-dialog title="充值" :visible.sync="dialogFormVisible" :width="isMobile()?'80%':'50%'">
      <el-form :model="rechargeForm" label-width="30%">
        <el-form-item label="设备类型">{{ rechargeForm.name }}</el-form-item>
        <el-form-item label="所属门店">{{
          rechargeForm.shopName
        }}</el-form-item>
        <el-form-item label="剩余次数">{{
          rechargeForm.useNumber
        }}</el-form-item>
        <el-form-item label="充值次数">
          <el-input
            type="number"
            v-model="rechargeForm.quantity"
            auto-complete="off"
            placeholder="请输入充值数量"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="recharge">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      query: {
        id: null,
        name: null,
        shopId: null,
      },
      dealerSn: "",
      typeId: null,
      statusList: [
        { text: "正常", value: 0 },
        { text: "禁用", value: 1 },
      ],
      dialogFormVisible: false,
      rechargeForm: {
        id: null,
        name: null,
        shopName: null,
        useNumber: null,
        quantity: null,
      },
    };
  },
  created: function () {
    let that = this;
    let query = that.getQuery();
    that.query.id = query.id ? parseInt(query.id) : null;
    that.query.name = query.name;
    that.query.shopId = query.shopId ? parseInt(query.shopId) : null;
  },
  methods: {
    dateFormatter(row, column, cellValue, index) {
      return this.dateFormat("yyyy-mm-dd HH:MM:SS", new Date(cellValue));
    },
    statusFormatter(row, column, cellValue, index) {
      return cellValue == 0 ? "正常" : "禁用";
    },
    search() {
      let that = this;
      let params = Object.assign(this.getQuery(), this.query);
      params.page = 1;
      this.$router.replace({ query: params }, null, function () {
        that.$router.go(0);
      });
    },
    exportData() {
      let that = this;
      let params = Object.assign(this.getQuery(), this.query);
      params.page = 1;
      that.api.dealer.type.exportData(params).then((response) => {
        if (!response.data.errorCode) {
          that.downloadExcel(response.data.data);
        }
      });
    },
    handleRecharge(index, row) {
      this.rechargeForm.id = row.id;
      this.rechargeForm.name = row.name;
      this.rechargeForm.shopName = row.shopName;
      this.rechargeForm.useNumber = row.useNumber;
      this.rechargeForm.quantity = null;
      this.dialogFormVisible = true;
    },
    recharge() {
      let params = {
        typeId: this.rechargeForm.id,
        quantity: this.rechargeForm.quantity,
      };
      let that = this;
      this.api.dealer.type
        .recharge(Object.assign({}, params))
        .then(function (response) {
          if (!response.data.errorCode) {
            that.dialogFormVisible = false;
            that.$message({
              type: "success",
              message: "充值成功！",
              onClose: function () {},
            });
            that.$router.go(0);
          }
        });
    },
    getQuery() {
      return Object.assign({}, this.$route.query);
    },
  },
};
</script>

<style scoped>
@media screen and (max-device-width: 960px) {
  .search-input {
    width: 105px;
  }
}
@media screen and (min-device-width: 960px) {
  .search-input {
    width: 150px;
  }
}
.search-box span {
  display: inline-block;
  padding: 2px 2px 2px 0px;
}
.search-box span label {
  display: inline-block;
  width: 55px;
}
</style>


// WEBPACK FOOTER //
// List.vue?700d4506